/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Field, ErrorMessage, FieldArray } from 'formik';
import {
   Grid,
   TextField,
   Box,
   Typography,
   Select,
   MenuItem,
   InputLabel,
   FormControl,
   Chip,
   FormHelperText,
} from '@mui/material';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '../../../Utils/RichEditor';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';

function StepFiveUpdate({ isSubmitting, values, setFieldValue, touched, errors, initialValues }) {
   const bankList = useSelector((state) => state.contractState.bankDetails);

   const [BankOptions, setBankOptions] = useState([]);
   const [selectedBank, setSelectedBank] = useState([]);
   const isInitializedRef = useRef(false);

   // Redux State for Contract Prefilled Data
   const contractPrefilledDataForUpdate = useSelector(
      (state) => state.contractState.contractUpdatePrefilledData,
   );

   useEffect(() => {
      setBankOptions(bankList || []);
   }, [bankList]);

   // Prefill Bank_Details (ids) once prefilled data + bankList are both available
   useEffect(() => {
      if (isInitializedRef.current) return;
      if (values.Bank_Details && values.Bank_Details.length > 0) {
         isInitializedRef.current = true;
         return;
      }

      const bankIds =
         contractPrefilledDataForUpdate?.bank?.map((item) => String(item.id)) || [];

      if (bankIds.length > 0) {
         setFieldValue('Bank_Details', bankIds);
         isInitializedRef.current = true;
      }
   }, [contractPrefilledDataForUpdate, values.Bank_Details, setFieldValue]);

   // Sync selectedBank display whenever Bank_Details or bankList changes
   useEffect(() => {
      if (values.Bank_Details && values.Bank_Details.length > 0) {
         const source =
            bankList && bankList.length > 0
               ? bankList
               : contractPrefilledDataForUpdate?.bank || [];

         const updatedSelectedBank = values.Bank_Details
            .map((id) => source.find((item) => String(item.id) === String(id)))
            .filter(Boolean);

         setSelectedBank(updatedSelectedBank);
      } else {
         setSelectedBank([]);
      }
   }, [values.Bank_Details, bankList, contractPrefilledDataForUpdate]);

   const handleAddBank = (BankId) => {
      if (!BankId) return;

      const selectedBankItem = bankList?.find((item) => String(item.id) === String(BankId));
      if (!selectedBankItem) return;

      const currentBankIds = values.Bank_Details || [];

      if (currentBankIds.some((id) => String(id) === String(BankId))) {
         return;
      }

      const newBankList = [...currentBankIds, BankId];
      setFieldValue('Bank_Details', newBankList);
   };

   const handleRemoveBank = (bankId) => {
      const currentBankIds = values.Bank_Details || [];
      const updatedBankIds = currentBankIds.filter((id) => String(id) !== String(bankId));
      setFieldValue('Bank_Details', updatedBankIds);
   };

   return (
      <>
         <div className="card stepCard">
            <Box className="card-body" sx={{ padding: '15px' }}>
               <Grid item xs={12}>
                  <Box className="commonBox">
                     <Typography variant="h6" gutterBottom align="left">
                        Select Bank Account <span style={{ color: 'red' }}>*</span>
                        <span
                           style={{
                              display: 'inline-block',
                              backgroundColor: '#d32f2f',
                              color: '#fff',
                              fontSize: '0.85em',
                              fontWeight: 500,
                              borderRadius: '16px',
                              padding: '2px 12px',
                              marginLeft: '8px',
                              verticalAlign: 'middle',
                           }}
                        >
                           Required
                        </span>
                     </Typography>
                     <Grid container spacing={2}>
                        <Grid item xs={12}>
                           <FormControl fullWidth>
                              {selectedBank.length === 0 && <InputLabel
                                 id="bank-account-label"
                                 sx={{ backgroundColor: '#fff', px: 0.5 }}
                              >
                                 Select Bank Account <span style={{ color: 'red' }}>*</span>
                              </InputLabel>}
                              <Select
                                 labelId="bank-account-label"
                                 value={values?.selected_bank_account || ''}
                                 onChange={(e) => {
                                    handleAddBank(e.target.value);
                                 }}
                                 displayEmpty
                                 renderValue={() => {
                                    if (selectedBank.length === 0) {
                                       return 'Select Bank Account';
                                    }

                                    return (
                                       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                          {selectedBank.map((bank) => (
                                             <Chip
                                                key={bank.id}
                                                label={bank.bank_name}
                                                size="small"
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onDelete={() => handleRemoveBank(bank.id)}
                                             />
                                          ))}
                                       </Box>
                                    );
                                 }}
                              >
                                 <MenuItem value="" disabled>
                                    Select Bank Account
                                 </MenuItem>
                                 {BankOptions?.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                       {option.bank_name} - ********
                                       {option.account_no.substring(
                                          option.account_no.length - 4,
                                       )} : {option.ifsc_Code}
                                    </MenuItem>
                                 ))}
                              </Select>
                              {touched.Bank_Details && errors.Bank_Details && (
                                 <FormHelperText sx={{color: "red"}}>{errors.Bank_Details}</FormHelperText>
                              )}
                           </FormControl>

                           {/* <ErrorMessage
                              name="selected_bank_account"
                              component="div"
                              style={{ color: 'red' }}
                           /> */}
                        </Grid>

                        {/* <Grid item xs={12}>
                           <Typography variant="subtitle1">
                              Selected Bank Account Details:
                           </Typography>
                           {selectedBank.length > 0 && (
                              <Box>
                                 {selectedBank?.map((Bank, index) => (
                                    <Box
                                       key={index}
                                       sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          mb: 1,
                                       }}
                                    >
                                       <Typography variant="body2">
                                          {Bank.bank_name} - ********
                                          {Bank.account_no?.substring(
                                             Bank.account_no.length - 4,
                                          )} : {Bank.ifsc_Code}
                                       </Typography>
                                       <Button
                                          onClick={() => handleRemoveBank(Bank.id)}
                                          startIcon={<DeleteIcon />}
                                          size="small"
                                          sx={{ ml: 1 }}
                                       >
                                          Remove
                                       </Button>
                                    </Box>
                                 ))}
                              </Box>
                           )}
                        </Grid> */}
                     </Grid>
                  </Box>
               </Grid>
            </Box>
         </div>
      </>
   );
}

export default StepFiveUpdate;